const inspectModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/conditions/condition-form/trigger-form/inspect-modal/inspect-modal.html',
  controller: 'InspectModalController',
};

angular
  .module('pis-tool.module')
  .component('inspectModal', inspectModal);
